import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthlyExpenseByMonthDatatable";

import { getSingleMonthlyCashSummaryRedux } from "../../../actions/index";
import { Link } from "react-router-dom";
import {
  recalculateCashSummaryFrom,
  canRecalculateCashSummary,
  CASH_SUMMARY_REBUILD_FLOOR_MONTH,
} from "../../../firebase/firebase.utils";

import { connect } from "react-redux";
import "./cash-summary.css";

export class MonthlyExpenseByMonth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
      rebuilding: false,
    };
  }

  componentDidMount = async () => {
    this.props.getSingleMonthlyCashSummaryRedux(this.props.match.params.month);
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };

  handleRebuild = async () => {
    const month = this.props.match.params.month;
    const confirmed = window.confirm(
      `Recalculate the cash summary for ${month} and every month after it, up to today?\n\n` +
        `Each day's Total Cash In / Total Cash Out will be re-derived from the approved entries dated that day, ` +
        `and Previous Cash / Remaining Cash will be re-chained from the balance carried into ${month}.\n\n` +
        `Stored figures for those days will be overwritten. Months before ${month} are not touched.`
    );
    if (!confirmed) return;

    this.setState({ rebuilding: true });
    const result = await recalculateCashSummaryFrom(month);
    this.setState({ rebuilding: false });

    if (!result.success) {
      toast.error(result.message || "Recalculation failed.");
      return;
    }

    if (result.daysWritten === 0) {
      toast.info(
        `Already correct — checked ${result.daysScanned} day(s) from ${month} to today, nothing to change.`
      );
    } else {
      toast.success(
        `Recalculated ${result.daysScanned} day(s): ${result.daysWritten} corrected` +
          `${result.daysCreated ? ` (${result.daysCreated} newly created)` : ""}, ` +
          `${result.daysUnchanged} already correct. ` +
          `Closing cash ${result.closingCash}Tk.`
      );
    }

    // Pull the corrected rows back into the table.
    this.props.getSingleMonthlyCashSummaryRedux(month);
  };

  render() {
    const month = this.props.match.params.month;
    const rebuildable = canRecalculateCashSummary(month);

    return (
      <Fragment>
        <Breadcrumb title={"Cash Summary"} parent="Cash" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid cs-page">
          <div className="row">
            <div className="col-sm-12">
              <div className="card cs-card">
                <div className="card-header cs-card-header cs-card-header--split">
                  <h5 className="cs-card-title">
                    <i className="icofont-calendar cs-card-icon"></i>
                    {month}
                  </h5>
                  <button
                    type="button"
                    className={`cs-rebuild-btn ${
                      this.state.rebuilding ? "cs-rebuild-btn--busy" : ""
                    }`}
                    disabled={!rebuildable || this.state.rebuilding}
                    title={
                      rebuildable
                        ? `Re-derive every day from ${month} to today from the approved entries`
                        : `Only ${CASH_SUMMARY_REBUILD_FLOOR_MONTH} onward can be recalculated`
                    }
                    onClick={this.handleRebuild}
                  >
                    <i className="icofont-refresh"></i>
                    {this.state.rebuilding
                      ? "Recalculating…"
                      : "Recalculate from this month"}
                  </button>
                </div>
                <div className="card-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      history={this.props.history}
                      myData={this.props.allExpenses}
                      pageSize={50}
                      pagination={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allExpenses: state.expenses.singleMonthCashSummary,
  };
};

export default connect(mapStateToProps, {
  getSingleMonthlyCashSummaryRedux,
})(MonthlyExpenseByMonth);
